import { render, staticRenderFns } from "./LoginChristmas.vue?vue&type=template&id=22708790&"
import script from "./LoginChristmas.vue?vue&type=script&lang=js&"
export * from "./LoginChristmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports